import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Circle from "../../../../../src/entities/Circle";
import PointManager from "./PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager";
import SliderManager from "./SliderManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import GuideText from "../../../../../src/entities/GuideText";
import { ARC_COLOR_ARR, CENTER_OF_CIRCLE, CIRCLE_RADIUS, INFO_SLIDER_COORD, INITIAL_RADIANS } from "../types/Config";
import isCircumPointBetween from "../../../../../src/utils/isCircumPointBetween";
import getCircleRadians from "../helpers/getCircleRadians";
import GenRanTriangleButton from "../entities/GenRandomTriangle";
import SegmentChord from "../entities/SegmentChord";


export default class ComponentManager {
  static instance:ComponentManager;
  Game = Game.getInstance();
  circleRadius = CIRCLE_RADIUS;
  cCoord = this.isPortail();

  PointManager = new PointManager(this.cCoord);
  PointTagManager = new PointTagManager(this.cCoord);
  LineManager = new LineManager();
  AngleManager = new AngleManager();
  SliderManager = new SliderManager();
  InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
  circle = new Circle(this.cCoord, INITIAL_RADIANS, ARC_COLOR_ARR);
  genRandomTriangle = new GenRanTriangleButton();
  SegmentChord = new SegmentChord(this.cCoord);

  CircleAnimationManager = new CircleAnimationManager(
    this.PointManager,
    this.AngleManager,
    this.LineManager,
    this.circle,
    this.cCoord
  )

  constructor() {
    new GuideText();
    rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    this.drawElements();
  }
  isPortail() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return CENTER_OF_CIRCLE
    }
    return {
      x: dim.WIDTH / 2,
      y: dim.HEIGHT / 2
    }
  }
  drawElements() {
    const points = this.PointManager.getRedPoints();
    const radians = this.PointManager.getRadians();
    const isBtw = isCircumPointBetween(this.cCoord, points[1], radians[0], radians[2]);

    this.circle.draw({ radians: getCircleRadians(radians, isBtw), radius: this.circleRadius });
    this.LineManager.draw(points);
    this.AngleManager.draw(points, isBtw);
    this.PointTagManager.updateCoord(radians, this.circleRadius);
    this.SegmentChord.draw(CIRCLE_RADIUS, [radians[2], radians[0]], [points[2], points[0]], isBtw);
  }
}